<template>
  <div class="rank-container">
    <div class="rank-top">
      <div class="top-left">营养师票数排行</div>
      <div class="top-right" @click="bindGet"
        >获取更多投票券<span class="iconfont icon-you"></span
      ></div>
    </div>
    <div class="vote-info">
      <div class="info-item item-left" @click="bindToInviteDetail"
        ><span>拉票数量</span
        ><span class="info-num">{{ userInfo.invite_vote_num }}张</span
        ><span class="iconfont icon-you"></span
      ></div>
      <div class="info-dash"
        ><div class="dash-item" v-for="(item, index) in 6" :key="index"></div
      ></div>
      <div class="info-item item-right"
        ><span>拥有投票券</span
        ><span class="info-num">{{ userInfo.user_vote_num }}张</span></div
      >
    </div>
    <div class="rank">
      <div class="rank-before">
        <img
          class="rank-bg"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4e1ec52e9eec4f3557a76df298448575.png"
          alt=""
        />
        <div
          class="rank-item"
          :class="['rank-item-' + index]"
          v-for="(item, index) in beforeList"
          :key="index"
        >
          <div class="item-avatar" @click="bindClickItem(item)">
            <img class="item-index" :src="beforeIconList[index].icon" alt="" />
            <img class="item-image" :src="item.c_image" alt="" />
          </div>
          <div class="item-name">{{ item.c_name }}</div>
          <div class="item-num">{{ item.vote_num }}票</div>
          <div class="item-btn-list">
            <div class="item-btn item-btn-left" @click="bindClickLeft(item)"
              >拉票</div
            >
            <div class="item-btn item-btn-right" @click="bindClickRight(item)"
              >投票</div
            >
          </div>
        </div>
      </div>
      <div class="rank-after">
        <div class="rank-item" v-for="(item, index) in afterList" :key="index">
          <div class="item-index">{{ index + 4 }}</div>
          <div class="item-content">
            <img
              class="item-avatar"
              @click="bindClickItem(item)"
              :src="item.c_image"
              alt=""
            />
            <div class="item-info">
              <div class="item-name">{{ item.c_name }}</div>
              <div class="item-num"
                ><span>{{ item.vote_num }}票</span
                ><span class="item-flag" v-if="item.is_my_coach"
                  >服务过我</span
                ></div
              >
            </div>
            <div class="item-btn item-btn-left" @click="bindClickLeft(item)"
              >拉票</div
            >
            <div class="item-btn item-btn-right" @click="bindClickRight(item)"
              >投票</div
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    coachInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    beforeList() {
      return this.coachInfo.slice(0, 3)
    },
    afterList() {
      return this.coachInfo.slice(3)
    }
  },
  data() {
    return {
      beforeIconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d0d5fa2630c4ac2fa7fd5f0a3c164745.png'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/47b4c0086f04e815976abf9d79ccc060.png'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7008ec00463930f87fe9daf0ba6eb494.png'
        }
      ]
    }
  },
  methods: {
    bindClickLeft(item) {
      this.$emit('invite', item)
    },
    bindClickRight(item) {
      this.$emit('vote', item)
    },
    bindGet() {
      this.$emit('get')
    },
    bindToInviteDetail() {
      this.$emit('inviteDetail')
    },
    bindClickItem(item) {
      this.$emit('avatar', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.rank-container {
  .rank-top {
    position: relative;
    z-index: 1;
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .top-left {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
    }

    .top-right {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #6236ff;
      line-height: 20px;

      .iconfont {
        margin-left: 4px;
        color: #979797;
      }
    }
  }

  .vote-info {
    position: relative;
    z-index: 1;
    margin-bottom: 30px;
    height: 32px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    border: 1px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;

    .info-item {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .item-left {
      justify-content: flex-end;
    }

    .item-right {
      justify-content: flex-start;
    }

    .info-num {
      margin-left: 12px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #6236ff;
      line-height: 22px;
    }

    .iconfont {
      margin-left: 11px;
    }

    .info-dash {
      width: 1px;
      height: 16px;
      margin: 0 23px 0 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .dash-item {
        width: 1px;
        height: 1px;
        background-color: #979797;
      }
    }
  }

  .rank {
    margin-bottom: 16px;

    .rank-before {
      height: 183px;
      padding: 0px 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      position: relative;
      z-index: 0;
      .rank-bg {
        position: absolute;
        left: 52%;
        top: 83px;
        transform: translate(-50%, -50%);
        width: 418px;
        height: 418px;
        z-index: -1;
      }
      .rank-item {
        position: absolute;
        width: 109px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-avatar {
          position: relative;
          width: 48px;
          height: 48px;
          margin: 0 auto 15px;

          .item-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
            overflow: hidden;
          }

          .item-index {
            position: absolute;
            width: 30px;
            height: 30px;
            right: 0;
            top: 0;
            transform: translate(50%, -50%);
          }
        }

        .item-name {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 17px;
        }

        .item-num {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 22px;
          margin-bottom: 7px;
        }

        .item-btn-list {
          position: relative;
          z-index: 0;
          display: flex;
          align-items: center;
        }
      }

      .rank-item-0 {
        left: 50%;
        top: 83px;
        transform: translate(-50%, -50%);
        .item-name {
          margin-bottom: 6px;
        }
        .item-avatar {
          margin-bottom: 24px;
        }
        .item-avatar,
        .item-name,
        .item-num {
          transform: scale(1.25);
        }
      }
      .rank-item-1 {
        left: 0%;
        top: 54%;
        transform: translate(0%, -50%);
      }
      .rank-item-2 {
        right: 3px;
        top: 54%;
        transform: translate(0%, -50%);
      }
    }

    .rank-after {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.8) 0%,
        #ffffff 100%
      );
      border-radius: 10px;
      position: relative;
      z-index: 2;
      /* height: 490px;
            overflow-y: scroll; */
      .rank-item {
        padding: 13px 0px 10px 12px;
        display: flex;
        align-items: flex-start;

        .item-index {
          margin-top: 8px;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          margin-right: 8px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.2);
        }

        .item-avatar {
          width: 36px;
          height: 36px;
          object-fit: cover;
          border-radius: 6px;
          margin-right: 8px;
        }

        .item-content {
          flex: 1;
          flex-shrink: 0;
          padding-right: 12px;
          overflow: hidden;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e7e7e7;
          padding-bottom: 12px;
          position: relative;
          z-index: 0;
        }

        .item-info {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 8px;

          .item-name {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
          }

          .item-num {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #6e4ce6;
            display: flex;
            align-items: center;

            .item-flag {
              line-height: 14px;
              height: 14px;
              background: #ff6a97;
              border-radius: 4px;
              font-size: 9px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ffffff;
              padding: 0px 4px;
              margin-left: 4px;
            }
          }
        }
      }
      .rank-item:last-child {
        .item-content {
          border-bottom: none;
        }
      }
    }

    .item-btn {
      position: relative;
      z-index: 1;
      text-align: center;
      width: 53px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }

    .item-btn-left::before {
      content: '';
      z-index: -1;
      background: #ff6a97;
      border-radius: 6px 0px 0px 6px;
      width: 70%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .item-btn-left::after {
      content: '';
      background: #ff6a97;
      border-radius: 0px 3px 3px 0px;
      width: 40%;
      height: 100%;
      transform: skewX(-20deg);
      position: absolute;
      right: 10%;
      top: 0;
      z-index: -1;
    }

    .item-btn-left {
      margin-right: -8px;
    }

    .item-btn-right::before {
      content: '';
      z-index: -1;
      background: #7757e7;
      border-radius: 0px 6px 6px 0px;
      width: 70%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-btn-right::after {
      content: '';
      background: #7757e7;
      border-radius: 3px 0px 0px 3px;
      width: 40%;
      height: 100%;
      transform: skewX(-20deg);
      position: absolute;
      left: 10%;
      top: 0;
      z-index: -1;
    }
  }
}
</style>
